<template>
  <div>
    <div class="report_title">{{ studentInfo.OrganizationName }}心理健康报告</div>
    <table class="detail_tab" cellspacing="0">
      <tbody>
        <!-- 量表标题 -->
        <tr>
          <td class="scale_title" colspan="3">{{ ScaleName }}</td>
        </tr>
        <!-- 人员基本信息 -->
        <tr>
          <td>姓名：{{ studentInfo.UserName }}</td>
          <td>身份证号：{{ studentInfo.IDCard }}</td>
        </tr>
        <tr>
          <td>性别：{{ studentInfo.SexName }}</td>
          <td>年龄：{{ studentInfo.Age }}岁</td>
        </tr>
        <!-- 图形数据展示 -->
        <tr class="title">
          <td colspan="3" class="sub_title">评估结果</td>
        </tr>
        <tr>
          <td colspan="3">
            <el-row v-if="dataArr.length <= 2" style="min-height: 350px">
              <el-col
                v-for="item in dataArr"
                :span="24 / dataArr.length"
                :key="item.id"
                style="position: relative"
              >
                <div
                  class="canvas-warp"
                  :id="item.id"
                  :style="'width:100%;height:350px'"
                ></div>
              </el-col>
            </el-row>
            <div v-else class="canvas_warp" style="display: flex; flex-wrap: wrap">
              <div
                v-for="(item, index) in dataArr"
                :key="index"
                :id="item.id"
                :style="'width:50%;height:350px;'"
              ></div>
            </div>
          </td>
        </tr>
        <tr class="title">
          <td colspan="3" class="sub_title">评语</td>
        </tr>
        <tr>
          <td colspan="3">
            <div class="content">
              <div v-for="(item, index) in ConclusionList" :key="index">
                {{ index + 1 }}、{{ item.conclusion }}
              </div>
            </div>
          </td>
        </tr>
        <tr class="title">
          <td colspan="3" class="sub_title">建议</td>
        </tr>
        <tr>
          <td colspan="3">
            <div class="content">
              <div v-for="(item, index) in SugList" :key="index">
                {{ index + 1 }}、{{ item }}
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- 心理老师和时间 -->
    <div class="create_user_name">
      <div class="teacher-style">
        <!-- <div>心理老师：{{studentInfo.TeacherName}}</div>  -->
        <div>四川蓝韵心理咨询服务有限公司</div>
          <div>
        {{ new Date(studentInfo.MMPTTime).format("yyyy-MM-dd") }}
      </div>
      </div>
    
    </div>
  </div>
</template>
<script>
import echarts from "echarts";
import westeros from "@/components/ECharts/theme/westeros";

export default {
  name: "detailReport",
  props: {
    admScaleID: {
      type: Number,
      default: 0,
    },
    schoolPersonType: {
      type: String,
      default: null,
    },
    isDetaled: {
      type: Boolean,
      default: false,
    },
    mmpt_record_id: {
      default: 0,
    },
  },
  data() {
    return {
      PostUrl: "MMPTBiz.GetMMPTReportById",
      userInfo: {},
      HospitalName: "",
      SugList: [],
      ConclusionList: [],
      ScaleName: "",
      studentInfo: {},
      dataArr: [],
      chart: null,
      ImageType: [
        {
          ID: 0,
          type: "none",
        },
        {
          ID: 1,
          type: "bar",
        },
        {
          ID: 2,
          type: "gauge",
        },
        {
          ID: 3,
          type: "radar",
        },
        {
          ID: 4,
          type: "seesaw",
        },
        {
          ID: 5,
          type: "pie",
        },
        {
          ID: 6,
          type: "rainbow",
        },
        {
          ID: 7,
          type: "line",
        },
      ],
      examine: "",
    };
  },
  methods: {
    findType(id) {
      return this.ImageType.find((m) => m.ID == id).type;
    },
    // 初始化echats
    initChart(options) {
      if (options) {
        this.chart = echarts.init(document.getElementById(options.id), "westeros");
        this.chart.setOption(options);
      }
    },
    radar(data) {},
    line(data) {},
    initData() {
      // 获取量表配置数据
      let self = this;
      /* 判断校内校外查看报告接口 */
      if (self.schoolPersonType && self.schoolPersonType == "outsiderPerson") {
        self.PostUrl = "MMPTBiz.GetMMPTReportById2";
      }
      // 教师测评查看报告
      else if (self.schoolPersonType && self.schoolPersonType == "teacher") {
        self.PostUrl = "MMPTBiz.GetMMPTReportById3";
      }

      LYCom.AsynCallBiz(
        (e) => {
          if (e.err) {
            self.$message.error("获取数据错误，" + e.err);
          } else {
            if (e.rtnObj) {
              // 保存请求结果
              var tempdata = e.rtnObj;
              // 量表标题
              self.ScaleName = tempdata.ScaleName;
              // 人员信息
              self.studentInfo = {
                OrganizationName: tempdata.OrganizationName,
                UserName: tempdata.UserName,
                IDCard: tempdata.IDCard,
                Age: tempdata.Age,
                SexName: tempdata.SexName,
                MMPTTime: tempdata.MMPTTime,
                TeacherName: tempdata.TeacherName,
              };
              let resultList = tempdata.MMPTResultList; // 建议/结论
              let configList = tempdata.ChartConfigList; // 图形配置数据
              let specialData; // 自定义建议
              if (resultList && resultList.length > 0) {
                for (let i = 0; i < resultList.length; i++) {
                  let item = resultList[i];
                  if (
                    item.suggestion != "" &&
                    item.suggestion != null &&
                    self.SugList.indexOf(item.suggestion) === -1
                  ) {
                    self.SugList.push(item.suggestion);
                  }
                }
                // 获取建议
                self.ConclusionList = resultList.filter((item) => {
                  return item.conclusion != "" && item.conclusion != null;
                });
              }
              // 自定义建议
              if (configList && configList.length > 0) {
                specialData = configList.filter((m) => m.chart_type == 6);
              }
              if (specialData && specialData.length > 0) {
                specialData.forEach((w) => {
                  self.ConclusionList.push({
                    conclusion: "总分:" + w.items[0].score + "分",
                  });
                });
              }
              // 组织图形配置
              if (configList && configList.length > 0) {
                var index = 0;
                configList.forEach((item) => {
                  var type = self.findType(item.chart_type);
                  if (item.items && item.items.length > 0) {
                    var result = {};
                    switch (type) {
                      case "bar":
                        result = self.convertbarData(item, index, tempdata);
                        break;
                      case "line":
                        result = self.convertlineData(item, index, tempdata);
                        break;
                      case "gauge":
                        result = self.convertgaugeData(item, index, tempdata);
                        break;
                      case "radar":
                        result = self.convertradarData(item, index, tempdata);
                        break;
                      case "seesaw":
                        result = self.convertSeeSawData(item, index, tempdata);
                        break;
                      case "pie":
                        result = self.convertPieData(item, index, tempdata);
                        break;
                      case "rainbow":
                        result = self.convertRainbowData(item, index, tempdata);
                        break;
                      case "none":
                        result = 0;
                        break;
                      default:
                        break;
                    }
                    index++;
                    self.dataArr.push(result);
                    console.log(self.dataArr);
                    self.$nextTick(() => {
                      setTimeout(() => {
                        //  执行echarts方法
                        self.initChart(result);
                      }, 100);
                    });
                  }
                });
              }
            } else {
              self.taskList = [];
              self.opt = true;
            }
          }
        },
        // "MMPTBiz.GetMMPTReportById",
        self.PostUrl,
        LYCom.GetToken(),
        self.mmpt_record_id
      );
    },
    /* 柱状图 */
    convertbarData(data, index, tempdata) {
      var dataAxis = [];
      var tempData = [];
      var max = 0,
        min = 0;
      data.items.forEach((item) => {
        dataAxis.push(item.rule_name);
        tempData.push(item.score);
        if (max < item.max) {
          max = item.max;
        }
        if (min > item.min) {
          min = item.min;
        }
      });
      let markLine = {};
      var barcolor = "";
      let Fn = "";
      // 判断是否有额外配置参数
      if (data.range_description) {
        var RangeDescribe = JSON.parse(data.range_description);
        markLine = RangeDescribe.markLine;
        if (RangeDescribe.color) barcolor = RangeDescribe.color;
        if (
          RangeDescribe.itemStyle &&
          RangeDescribe.itemStyle.normal &&
          RangeDescribe.itemStyle.normal.color
        ) {
          Fn = RangeDescribe.itemStyle.normal.color;
        }
      }
      let options = {
        id: (this.isDetaled ? "dp" : "kp") + index,
        xAxis: {
          data: dataAxis,
          axisLabel: {
            inside: false,
            interval: 0,
            rotate: 30,
            textStyle: {
              color: "#a0a0f0",
            },
          },
          z: 10,
        },
        yAxis: {
          type: "value",
          max: max,
          min: min,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#999",
            },
          },
        },
        dataZoom: [
          {
            type: "inside",
          },
        ],
        series: [],
      };

      options.series.push({
        type: "bar",
        name: data.title,
        label: {
          show: true,
        },
        itemStyle: {
          normal: {
            color: function (params) {
              let getColor = eval(Fn);
              return getColor;
            },
          },
        },
        color: barcolor,
        data: tempData,
        markLine: markLine,
      });
      return options;
    },
    // 折线图
    convertlineData(data, index, tempdata) {
      var dataAxis = [];
      var markline = "";
      var tempData = [];
      var yAxisConfig = {
        max: 0,
        min: 0,
        type: "value",
        data: [],
      };
      var max = 0,
        min = 0;
      data.items.forEach((item) => {
        dataAxis.push(item.rule_name);
        tempData.push(item.score);
        if (max < item.max) {
          max = item.max;
        }
        if (min > item.min) {
          min = item.min;
        }
      });

      if (data.range_description) {
        var RangeDescribe = JSON.parse(data.range_description);
        if (RangeDescribe.series) {
          markline = RangeDescribe.series.markLine;
        }
        //设置max min 在轮询设置max之后,再绑定max的值
        if (RangeDescribe.yAxis) {
          if (RangeDescribe.yAxis.max != 0) {
            max = RangeDescribe.yAxis.max;
          }
          if (RangeDescribe.yAxis.min != 0) {
            min = RangeDescribe.yAxis.min;
          }
          if (RangeDescribe.yAxis.type) {
            if (RangeDescribe.yAxis.type == "category") {
              yAxisConfig.type = RangeDescribe.yAxis.type;
              yAxisConfig.data = dataAxis;
              dataAxis = null;
            }
          }
        }
      }
      let options = {
        id: (this.isDetaled ? "dp" : "kp") + index,
        xAxis: {
          data: dataAxis,
          axisLabel: {
            inside: false,
            interval: 0,
            rotate: 30,
            textStyle: {
              color: "#a0a0f0",
            },
            max: max,
            min: min,
          },
          z: 10,
          // splitLine:{
          //   show:false  去除虚线
          // }
        },
        yAxis: {
          type: yAxisConfig.type,
          data: yAxisConfig.data,
          max: max,
          min: min,
          axisLine: {
            show: false,
          },
          axisTick: {
            interval: 0,
            show: false,
          },
          axisLabel: {
            interval: 0,
            textStyle: {
              color: "#999",
            },
          },
          splitLine: {
            show: false,
          },
        },
        dataZoom: [
          {
            type: "inside",
          },
        ],
        series: [],
      };
      options.series.push({
        type: "line",
        name: data.title,
        label: {
          show: true,
        },
        data: tempData,
        markLine: markline,
      });

      return options;
    },
    // 仪表盘
    convertgaugeData(data, index, tempdata) {
      var between = JSON.parse(data.range_description);
      var max = 0,
        min = 0;
      var detail = {};
      if (between) {
        if (between.color && between.color.length > 0) {
          between.color.forEach((item) => {
            if (item.max >= max) {
              max = item.max;
            }
            if (item.min <= min) {
              min = item.min;
            }
          });
        }
        if (between.detail) {
          detail = between.detail;
        }
      }
      let options = {
        id: (this.isDetaled ? "dp" : "kp") + index,
        tooltip: {
          formatter: "{a} <br/>{b} : {c}分",
        },
        title: {
          text: tempdata.ChartConfigList[index].title,
          bottom: "15%",
          left: "center",
        },
        series: [],
      };
      var tempData = [];
      data.items.forEach((item1) => {
        tempData.push({
          value: item1.score,
          name: "总分",
        });
      });

      var colorArea = this.getColorArea(data.range_description);
      options.series.push({
        type: "gauge",
        name: data.Title,
        axisLine: {
          lineStyle: {
            color: colorArea,
          },
        },
        detail: detail,
        min: min,
        max: max,
        data: tempData,
      });
      return options;
    },
    // 跷跷板图形
    convertSeeSawData(data, index, tempdata) {
      var datascore = data.items.filter((m) => m.rule_name != "总分");
      var factor = {
        left: datascore[0],
        right: datascore[1],
      };
      var point = {
        left: 1650,
        right: 1650,
      };
      var Bracket = {
        left: 550,
        right: 550,
      };
      if (factor.left.score > factor.right.score) {
        point.left = point.left - 1100;
        point.right = point.right + 1100;
        Bracket.left = Bracket.left - 550;
        Bracket.right = Bracket.right + 550;
      } else if (factor.left.score < factor.right.score) {
        point.right = point.right - 1100;
        point.left = point.left + 1100;
        Bracket.left = Bracket.left + 550;
        Bracket.right = Bracket.right - 550;
      }
      var markLineOpt = {
        animation: true,
        lineStyle: {
          type: "solid",
          width: 5,
        },

        data: [
          [
            {
              coord: [0, Bracket.left],
              symbol: "none",
            },
            {
              coord: [1100, Bracket.right],
              symbol: "none",
            },
          ],
        ],
      };

      var options = {
        id: (this.isDetaled ? "dp" : "kp") + index,
        title: {
          text: tempdata.ScaleName,
          textStyle: {
            fontSize: 14,
            fontWeight: 500,
          },
        },
        legend: {
          emphasis: {
            rich: {
              b: {
                height: 40,
              },
            },
          },
        },
        tooltip: {
          //formatter: " {a}:<br />" + "分数: ({c})"
          formatter: function (a, b) {
            return a.seriesName + ":<br />" + "分数:" + a.data.score;
          },
        },
        xAxis: [
          {
            gridIndex: 0,
            min: 0,
            max: 1800,
            show: false,
          },
        ],
        yAxis: [
          {
            gridIndex: 0,
            min: 0,
            max: 1800,
            show: false,
          },
        ],
        series: [
          {
            name: "跷跷板",
            type: "scatter",
            xAxisIndex: 0,
            yAxisIndex: 0,
            markLine: markLineOpt,
          },
          {
            name: "支架",
            type: "pictorialBar",
            symbolSize: ["40", "40"],

            symbol: "triangle",
            itemStyle: {
              emphasis: {
                opacity: 1,
              },
            },
            data: [
              {
                value: [
                  (point.left + point.right) / 6,
                  ((point.left + point.right) / 6) * 2,
                ],
                symbolPosition: "center",
                score: "",
              },
            ],
            z: 12,
          },
          {
            name: factor.left.rule_name,
            type: "pictorialBar",
            symbolSize: ["80", "80"],
            itemStyle: {
              color: {
                type: "radial",
                x: 0.5,
                y: 0.5,
                r: 0.5,
                colorStops: [
                  {
                    offset: 0,
                    color: "#B452CD", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#FFD700", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            symbol: "circle",

            data: [
              {
                value: [0, point.left],
                symbolPosition: "center",
                score: factor.left.score,
              },
            ],
            z: 12,
          },
          {
            name: factor.right.rule_name,
            type: "pictorialBar",
            symbolSize: ["80", "80"],
            itemStyle: {
              color: {
                type: "radial",
                x: 0.5,
                y: 0.5,
                r: 0.5,
                colorStops: [
                  {
                    offset: 0,
                    color: "#B452CD", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#87CEFA", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            symbol: "circle",

            data: [
              {
                value: [1100, point.right],
                symbolPosition: "center",
                score: factor.right.score,
              },
            ],
            z: 12,
          },
        ],
      };
      return options;
    },
    // 饼状图（暂无对应量表）
    convertPieData(data, index, tempdata) {},
    // 雷达图
    convertradarData(data, index, tempdata) {
      let options = {
        id: (this.isDetaled ? "dp" : "kp") + index,
        title: {
          text: tempdata.ScaleName,
          textStyle: {
            fontSize: 14,
            fontWeight: 500,
          },
          subtext: data.title,
        },
        tooltip: {},
        series: [],
      };
      var tempData = [];
      var indicator = [];
      data.items.forEach((item1) => {
        var max = 0,
          min = 0;
        if (max < item1.max) {
          max = item1.max;
        }
        if (min > item1.min) {
          min = item1.min;
        }
        indicator.push({
          min: min,
          max: max,
          name: item1.rule_name,
        });
        tempData.push(item1.score);
      });
      options.radar = {
        indicator: indicator,
        name: {
          textStyle: {
            color: "#fff",
            backgroundColor: "#999",
            borderRadius: 3,
            padding: [3, 5],
          },
        },
      };
      options.series.push({
        type: "radar",
        name: tempdata.ScaleName,
        label: {
          show: true,
          position: "insideBottom",
        },
        data: [
          {
            value: tempData,
            name: data.title,
            label: {
              show: true,
              position: "insideBottom",
            },
          },
        ],
      });
      return options;
    },
    // 彩虹图   （幸福感指数)
    convertRainbowData(data, index, tempdata) {
      var max = 0,
        min = 0,
        score = 0;
      var dataAxis = [];
      var tempData = [];
      var totalScore = 0;
      data.items.forEach((item) => {
        dataAxis.push(item.rule_name);
        tempData.push(item.score);
        score = Math.round(item.score);
        totalScore = item.score;
        if (max < item.max) {
          max = item.max;
        }
        if (min > item.min) {
          min = item.min;
        }
      });
      var average = max / 7;
      let options = {
        id: (this.isDetaled ? "dp" : "kp") + index,
        title: {
          text: tempdata.ScaleName + "(总分：" + totalScore + "分)",
          textStyle: {
            fontSize: 14,
            fontWeight: 500,
          },
        },
        visualMap: {
          top: 20,
          left: 2,
          pieces: [
            {
              gt: min,
              lte: average * 1,
              label: "紫【" + min + "-" + average * 1 + "分】",
              color: "#8B00FF",
            },
            {
              gt: average * 1,
              lte: average * 2,
              label: "蓝【" + average + "-" + average * 2 + "分】",
              color: "#0000FF",
            },
            {
              gt: average * 2,
              lte: average * 3,
              label: "青【" + average * 2 + "-" + average * 3 + "分】",
              color: "#00FFFF",
            },
            {
              gt: average * 3,
              lte: average * 4,
              label: "绿【" + average * 3 + "-" + average * 4 + "分】",
              color: "#00FF00",
            },
            {
              gt: average * 4,
              lte: average * 5,
              label: "黄【" + average * 4 + "-" + average * 5 + "分】",
              color: "#FFFF00",
            },
            {
              gt: average * 5,
              lte: average * 6,
              label: "橙【" + average * 5 + "-" + average * 6 + "分】",
              color: "#FF7F00",
            },
            {
              gt: average * 6,
              lte: average * 7,
              label: "红【" + average * 6 + "-" + max + "分】",
              color: "#FF0000",
            },
          ],
          outOfRange: {
            color: "#999",
          },
        },
        series: [
          {
            name: "红",
            type: "gauge",
            radius: "100%",
            startAngle: 180,
            endAngle: 0,
            splitNumber: 0, //刻度数量
            center: ["50%", "65%"],
            axisLine: {
              lineStyle: {
                width: 20,
                shadowBlur: 0,
                color: [[1, "#FF0000 "]],
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            detail: {
              show: false,
            },
            pointer: {
              show: false,
              length: "100%",
              width: 3,
              title: {
                show: false,
              },
            },
          },

          {
            name: "橙",
            type: "gauge",
            radius: "90%",
            startAngle: 180,
            endAngle: 0,
            splitNumber: 0, //刻度数量
            center: ["50%", "65%"],
            axisLine: {
              lineStyle: {
                width: 20,
                shadowBlur: 0,
                color: [[1, "#FF7F00"]],
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            detail: {
              show: false,
            },
          },
          {
            name: "黄",
            type: "gauge",
            radius: "80%",
            startAngle: 180,
            endAngle: 0,
            splitNumber: 0, //刻度数量
            center: ["50%", "65%"],
            axisLine: {
              lineStyle: {
                width: 20,
                shadowBlur: 0,
                color: [[1, "#FFFF00"]],
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            detail: {
              show: false,
            },
          },
          {
            name: "绿",
            type: "gauge",
            radius: "70%",
            startAngle: 180,
            endAngle: 0,
            splitNumber: 0, //刻度数量
            center: ["50%", "65%"],
            axisLine: {
              lineStyle: {
                width: 20,
                shadowBlur: 0,
                color: [[1, "#00FF00"]],
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            detail: {
              show: false,
            },
          },
          {
            name: "青",
            type: "gauge",
            radius: "60%",
            startAngle: 180,
            endAngle: 0,
            splitNumber: 0, //刻度数量
            center: ["50%", "65%"],
            axisLine: {
              lineStyle: {
                width: 20,
                shadowBlur: 0,
                color: [[1, "#00FFFF"]],
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            detail: {
              show: false,
            },
          },
          {
            name: "蓝",
            type: "gauge",
            radius: "50%",
            startAngle: 180,
            endAngle: 0,
            splitNumber: 0, //刻度数量
            center: ["50%", "65%"],
            axisLine: {
              lineStyle: {
                width: 20,
                shadowBlur: 0,
                color: [[1, "#0000FF"]],
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            detail: {
              show: false,
            },
          },
          {
            name: "紫",
            type: "gauge",
            radius: "40%",
            startAngle: 180,
            endAngle: 0,
            splitNumber: 0, //刻度数量
            center: ["50%", "65%"],
            axisLine: {
              lineStyle: {
                width: 20,
                shadowBlur: 0,
                color: [[1, "#8B00FF"]],
              },
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            detail: {
              show: false,
            },
          },
        ],
      };
      for (let index = 0; index < parseInt(max - score); index++) {
        options.series.shift();
      }
      return options;
    },

    // 获取颜色
    getColorArea(data) {
      var realdata = JSON.parse(data);
      var max = 0,
        min = 0;
      if (realdata && realdata.color) {
        var result = [];
        realdata.color.forEach((m) => {
          if (m.max > max) {
            max = m.max;
          }
          if (m.min < min) {
            min = m.min;
          }
        });
        realdata.color.forEach((m) => {
          var arr = [];
          var value = (m.max / max).toFixed(1);
          arr.push(value);
          arr.push(m.color);
          result.push(arr);
        });

        return result;
      } else {
        return [
          [0.2, "#91c7ae"],
          [0.8, "#63869e"],
          [1, "#c23531"],
        ];
      }
    },
  },

  mounted() {
    this.$nextTick(() => {
      //  执行echarts方法
      this.initData();
    });
  },
};
</script>
<style lang="less" scoped>
.report_title {
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: #000;
  margin-bottom: 5px;
}

.detail_tab {
  width: 100%;
  margin: 0 auto;
  border-top: 1px solid #000;
  border-left: 1px solid #000;
  border-collapse: collapse;

  tr {
    td {
      border-right: 1px solid #000;
      border-bottom: 1px solid #000;
      // border: none;
      line-height: 30px;
      font-size: 14px;
      color: #000;
      padding: 5px;
      margin: 0;

      .content {
        min-height: 100px;
        padding: 5px 20px;

        div {
          font-size: 14px;
          line-height: 30px;
          color: #000;
        }
      }
    }

    .sub_title {
      font-size: 15px;
      font-weight: 600;
      line-height: 30px;
      padding-left: 20px;
      color: #333;
    }

    .scale_title {
      text-align: center;
      line-height: 30px;
      font-size: 16px;
      color: #000;
    }
  }
}

.create_user_name {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.teacher-style {
  // width: 200px;
  text-align: left;
  font-size: 14px;
  font-weight: 400;
  font-family: "微软雅黑 Regular";
  text-align: right;
  color: #000;
}
.teacher-style div{
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/detailReport.vue